import { useTranslation } from "react-i18next";
import { Row, Col, HelpText } from "../../App.styles";
import { FormAutocomplete, RowInfo } from "../../common";
import { TimersModal } from "../modals";

const TimerSelect = (props) => {
    const { t } = useTranslation()
    const extendedTimers = [{
        id: 120,
        name: t(`120 (2 minutes)`),
    }, {
        id: 300,
        name: t(`300 (5 minutes)`)
    }, {
        id: 600,
        name: t(`600 (10 minutes)`)
    }, {
        id: 1800,
        name: t(`1800 (30 minutes)`)
    }, {
        id: 3600,
        name: t(`3600 (1 hour)`)
    }]

    return (
        <FormAutocomplete
          {...props}
          options={[
                ...Array(100)
                  .fill()
                  .map((_, i) => ({
                      id: i,
                      name: String(i),
                  })),
                ...extendedTimers,
          ]}
          size="small"
        />
      )
}

const TimersSection = ({ useQuery }) => {
  const { t } = useTranslation();
  
  return (
    <>
      <RowInfo help={<TimersModal />}>
        <TimerSelect
            help={t('If you want to add some pressure, set this above 0.')}
            label={t('Timer in seconds')}
            mode="clean"
            name="timer"
            useQuery={useQuery}
          />
      </RowInfo>
      <Row>
        <Col size="10">
          <HelpText className="position-relative top-0 mt-4 d-block" focus>
            Timers force the player to submit within the number of seconds specified.

            <p className="mt-2">
            0 indicates no timer.
            Players cannot use the back button to escape a timer.
            If a timer expires and the player hasn't submitted, a submission will automatically occur and the player will not get any points.
            </p>
          </HelpText>
        </Col>
      </Row>
    </>
  )
};

export default TimersSection;
